<template>
  <div class="content_record">
    <!--    搜索框-->
    <div class="search_box">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item>
          <el-date-picker
              v-model="formInline.time"
              type="datetimerange"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-select v-model="formInline.station" placeholder="充电桩枪号" clearable>
            <el-option label="停车场充电站1" value="station1"></el-option>
            <el-option label="停车场充电站2" value="station2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="formInline.station" placeholder="交易状态" clearable>
            <el-option label="未支付" :value="0"></el-option>
            <el-option label="充电中" :value="1"></el-option>
            <el-option label="失败" :value="2"></el-option>
            <el-option label="退款完成" :value="3"></el-option>
            <el-option label="完成" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input placeholder="订单号/联系电话/用户号码"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit" class="btn">搜索</el-button>
          <el-button type="primary" @click="upLoad" class="btn">导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--    表格-->
    <el-table
        :data="tableData"
        style="width: 100%"
        :header-cell-style='{background: "#6cc9eb", color: "#fff"}'
    >
      <el-table-column
          prop="date"
          show-overflow-tooltip
          label="订单号">
      </el-table-column>
      <el-table-column
          prop="name"
          show-overflow-tooltip
          label="用户名称">
      </el-table-column>
      <el-table-column
          show-overflow-tooltip
          prop="address"
          label="联系电话">
      </el-table-column>
      <el-table-column
          prop="address"
          show-overflow-tooltip
          label="充值金额">
      </el-table-column>
      <el-table-column
          prop="address"
          show-overflow-tooltip
          label="退款金额">
      </el-table-column>
      <el-table-column
          prop="address"
          show-overflow-tooltip
          label="充电桩枪号">
      </el-table-column>
      <el-table-column
          prop="address"
          show-overflow-tooltip
          width="150"
          label="充电电量(kWh)">
      </el-table-column>
      <el-table-column
          prop="address"
          show-overflow-tooltip
          width="150"
          label="充电时长(分钟)">
      </el-table-column>
      <el-table-column
          prop="address"
          show-overflow-tooltip
          label="交易状态">
      </el-table-column>
      <el-table-column
          prop="address"
          show-overflow-tooltip
          label="创建时间">
      </el-table-column>
    </el-table>
    <el-pagination
        style="text-align: right; margin-top: 23rem"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage4"
        :page-sizes="[100, 200, 300, 400]"
        :page-size="100"
        layout="total, sizes, prev, pager, next, jumper"
        :total="400">
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: "content_record",
  data() {
    return {
      formInline: {
        station: '',
        time: []
      },
      tableData: [{
        date: '2016-05-02',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-04',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1517 弄'
      }, {
        date: '2016-05-01',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1519 弄'
      }, {
        date: '2016-05-03',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1516 弄'
      }]
    }
  },

  methods: {
    onSubmit() {
      console.log('查询!');
    },

    upLoad() {
      console.log('导出')
    }
  }
}
</script>

<style scoped lang="less">
::v-deep .el-input__inner {
  height: 42rem;
  font-size: 18rem;
}

::v-deep .el-form-item {
  margin-bottom: 0;
}

::v-deep .el-table {
  font-size: 18rem;
}


.content_record {
  font-size: 18rem;

  .search_box {
    margin-bottom: 24rem;

    .btn {
      width: 100rem;
      height: 42rem;
      font-size: 18rem;
      border-radius: 0;
    }
  }
}

</style>